 <script>
    import { createEventDispatcher } from 'svelte';

    export let links = {
      twitter: "https://twitter.com/climatechoices",
      facebook: "https://www.facebook.com/ClimateChoices",
      linkedin: "https://www.linkedin.com/company/climatechoices/"
    };
    const dispatch = createEventDispatcher();

    function toTop() {
        dispatch('goToTop');
    }
 </script>
 
 <ul class="social-links">
  <li class="item">
    <a class="link" href="#top" on:click={() => toTop()} id="myBtn" title="Back to top">
      <svg class="icon arrow"  xmlns="http://www.w3.org/2000/svg" viewBox="0 50 240 240" width="27px" height="27px">
        <path d="M235 235 H5 L120 110z" />
      </svg>
    </a> 
  </li>
  <li class="item">
  <a class="link" href={links.facebook} title="Facebook" target="_blank">
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M17.719 9A8.717 8.717 0 009 .281 8.717 8.717 0 00.281 9a8.722 8.722 0 007.357 8.613V11.52H5.423V9h2.215V7.08c0-2.186 1.3-3.393 3.293-3.393.954 0 1.952.17 1.952.17v2.145h-1.1c-1.083 0-1.42.672-1.42 1.361V9h2.417l-.386 2.52h-2.032v6.093A8.722 8.722 0 0017.72 9z"></path></svg>          
  </a>
  </li>

  <li class="item">
    <a class="link" href={links.twitter} title="Twitter" target="_blank">
      <svg class="icon" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M9 18A9 9 0 109 0a9 9 0 000 18z"></path><path d="M7.353 13.748c3.992 0 6.174-3.308 6.174-6.175 0-.094 0-.189-.004-.279a4.446 4.446 0 001.084-1.125 4.404 4.404 0 01-1.246.342c.45-.27.791-.693.954-1.201a4.394 4.394 0 01-1.377.526 2.17 2.17 0 00-3.695 1.98A6.156 6.156 0 014.77 5.548c-.184.32-.292.693-.292 1.09 0 .751.382 1.417.967 1.804a2.132 2.132 0 01-.981-.27v.027c0 1.053.747 1.926 1.741 2.129a2.163 2.163 0 01-.98.036A2.167 2.167 0 007.25 11.87a4.362 4.362 0 01-3.213.896 6.05 6.05 0 003.316.98z" fill="#fff"></path></svg>          </a>
  </li>

  <li class="item">
    <a class="link" href={links.linkedin} title="LinkedIn" target="_blank">
      <svg class="icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.661.741H2.108A1.7 1.7 0 00.414 2.435v13.553a1.7 1.7 0 001.694 1.694h13.553a1.7 1.7 0 001.694-1.694V2.435A1.7 1.7 0 0015.662.741zm-10.164 13.5H2.955V7.094h2.542v7.147zm-1.27-8.497c-.848 0-1.526-.635-1.526-1.43 0-.793.678-1.429 1.525-1.429.847 0 1.525.636 1.525 1.43 0 .794-.678 1.43-1.525 1.43zm10.587 8.497h-2.54v-4.209c0-.635-.594-1.19-1.271-1.19-.678 0-1.271.555-1.271 1.19v4.21H7.19V7.093h2.54v.953c.425-.635 1.356-1.112 2.119-1.112 1.609 0 2.964 1.27 2.964 2.78v4.526z"></path></svg>          </a>
  </li>
 </ul>
<style>

.social-links {
  display: flex;
  flex-direction: row;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
}
.link {
    /* color: var(--teal); */
    /* color: var(--lilac-medium); */
    color: var(--lilac-dark);
    display: block;
    padding: 1rem;
}

.icon {
    fill: currentColor;
    stroke: currentColor;
    stroke-width: 0;
    display: block;
    max-width: 100%;
    position: relative;
    width: 30px;
    height: 30px;
}

.icon.arrow {
  fill: white;
  stroke-width: 7;
  filter: url(#fTexture3);
    stroke: var(--voila-border);
}
</style>
